import React, { useEffect, useRef, useState } from "react"
import works from "services/works"
import { useDispatch, useSelector } from "react-redux"
import Spinner from "components/Spinner/Home"
import L from "leaflet"
import "leaflet-plugins/layer/tile/Yandex"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "./style.css"
import "leaflet-routing-machine/dist/leaflet-routing-machine"
import "leaflet-routing-machine/dist/leaflet-routing-machine.css"
import "leaflet-control-geocoder/dist/Control.Geocoder"
import "leaflet-control-geocoder/dist/Control.Geocoder.css"
import { classNames } from "utils/classNames"
import Filter from "components/Icons/Filter"

import {
  Cards,
  FilterBlock,
  FilterButton,
  ListViewed,
  MapSection,
  StepperBlock,
  ZoomButton,
} from "./style"
import visitor from "services/visitor"
import ReactSlider from "react-slider"
import moment from "moment"
import { sliderData, filterElement } from "./helper"
import Arrow from "../../assets/icons/arrow.png"
import MapCards from "components/Cards/MapCards"
import ScreenResizeIcon from "components/Icons/ScreenResizeIcon"
import DropdownFilter from "../../components/Filters/Dropdown"
import myLocation from "../../assets/icons/location.svg"
import zoomPlus from "../../assets/icons/plus.svg"
import zoomMinus from "../../assets/icons/minus.svg"
import Stepper from "components/Stepper"
import { MdOutlineClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { setOpenPopupId } from "redux/modules/geoLocation/actions"
import { fetchUserCreditionals } from "redux/modules/userDatas/actions"
import visitorService from "../../services/visitor"
import Empty from "components/Empty"
import patterns from "services/patterns"
import "leaflet-routing-machine/dist/leaflet-routing-machine"
import "leaflet-routing-machine/dist/leaflet-routing-machine.css"
import "leaflet-control-geocoder/dist/Control.Geocoder"
import "leaflet-control-geocoder/dist/Control.Geocoder.css"
import RouteMap from "../../components/Map"
import { useShowAlert } from "hooks/customAlert"

import DefaultImage from "assets/images/default.png"

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("../../assets/icons/marker.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

const Home = () => {
  const { t } = useTranslation()
  const [openCards, setOpenCards] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)
  const [openStepper, setOpenStepper] = useState(false)
  const [yearStep, setYearStep] = useState([
    0,
    Number(Number(moment().year()) - 1900),
  ])
  const [listOpen, setListOpen] = useState([])
  const [routeCoordinates, setRouteCoordinates] = useState([])
  const language = localStorage.getItem("lang")
  const openPopupId = useSelector(
    (state) => state.geoLocationReducer.openPopupId
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [mapData, setMapData] = useState([])
  const [recommended, setRecommended] = useState()
  const [mapType] = useState("map")
  const [pattern, setPattern] = useState([])
  const [userLocation, setlUserLocation] = useState({})
  const { error } = useShowAlert()

  const [sliderValue, setSliderValue] = useState([
    0,
    Number(Number(moment().year()) - 1900),
  ])
  const { token } = useSelector((state) => state.userDatasReducer)
  const { filters: navbarFilter } = useSelector((state) => state.appReducer)

  const [filterData, setFilterData] = useState({
    year: {},
    group: {},
    region: {},
    category: {},
    title: navbarFilter?.search,
  })

  // const { showBlured } = useShowModal()
  // const { hideModal } = useHideModal()
  const [mapContainer, setMapContainer] = useState(undefined)
  const mapRef = useRef(null)
  const [loading, setLoading] = useState(false)
  // const [patternsState, setPatternsState] = useState([])
  const [isLoad, setIsLoad] = useState(false)
  const stepArray = ["", "1-kun", "2-kun", "3-kun", "4-kun", "5-kun"]
  const [currentStep] = useState(2)
  // const [localFilters, setLocalFilters] = useState()
  // const [isOpen, setIsOpen] = useState(false)
  // function totggleFilter() {
  //   setIsOpen((prev) => !prev)
  // }
  // const clearFilter = () => {
  //   setLocalFilters({})
  // }

  // useEffect(() => {
  //   if () {

  //   }
  // }, [])

  // const fetchPatterns = () => {
  //   patterns.getAll().then((res) => {
  //     setPatternsState(res)
  //   })
  // }

  useEffect(() => {
    setFilterData(() => ({
      ...filterData,
      title: navbarFilter?.search,
    }))
  }, [navbarFilter?.search])

  const fetchMapData = async () => {
    try {
      setLoading(true)
      const reqBody = {}
      // if (recommended["recommends"]) {
      //   reqBody["recommends"] = recommended["recommends"]
      // }
      // if (filterData["year"]?._id) {
      //   reqBody["year"] = filterData["year"]?._id
      // }
      if (sliderData[sliderValue[0]]) {
        reqBody["startYear"] = sliderData[sliderValue[0]]
      }
      if (sliderData[sliderValue[1]]) {
        reqBody["endYear"] = sliderData[sliderValue[1]]
      }
      if (filterData["region"]?._id) {
        reqBody["region"] = filterData["region"]?._id
      }
      if (filterData["category"]?._id) {
        reqBody["subCategory"] = filterData["category"]?._id
      }
      if (filterData?.title?.length) {
        reqBody["title"] = filterData?.title
      }

      let userDatas = []
      if (token) {
        userDatas = await visitor.getVisitorDatas({
          selected: "selected",
          limit: 1000,
          page: 1,
        })
      }
      const result = await works.getAllForMap(reqBody)
      setListOpen(result)
      const favouriteDatas = userDatas?.docs?.map((item) => item._id)
      const coordinates = result
        ?.filter((itm) => itm?.lat !== null && itm?.lat !== null)
        .map((item) => ({
          id: item._id,
          coords: [item?.lat, item?.lng],
          region: item.region?.title,
          group: item.group?.title,
          // favourite: true,
          title: item?.title,
          favourite: favouriteDatas?.includes(item._id),
          category: item.category?.title,
          subCategory: item.subCategory?.title,
          desc: item.desc,
          image: item.media && item.media[0],
        }))
      setMapData(coordinates)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // setTimeout(() => {
    if (filterData?.title?.length) {
      const timeInterval = setTimeout(() => {
        fetchMapData()
      }, 700)

      return () => clearTimeout(timeInterval)
    } else {
      fetchMapData()
    }
    // }, 2000)
    // return () => setSliderValue([0, Number(Number(moment().year()) - 1200)])
  }, [filterData, sliderValue, mapType, language])

  // useEffect(() => {
  //   if (token) {
  //     fetchPatterns()
  //   }
  // }, [])

  useEffect(() => {
    let demo = recommended && Object.keys(recommended).length
    if (demo) {
      setIsLoad(false)
      let id = recommended?.recommends?._id
      patterns
        .getOne(id)
        .then((res) => {
          setPattern(res)

          const result = res?.items?.map((itm) => ({
            lat: itm?.object?.media[0]?.lat,
            lng: itm?.object?.media[0]?.lng,
          }))
          setRouteCoordinates(result)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => setIsLoad(true))
    }
  }, [recommended])

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const latlng = new L.LatLng(
        parseFloat(position.coords?.latitude),
        parseFloat(position.coords?.longitude)
      )
      setlUserLocation(latlng)
    })

    const container = L.DomUtil.get(mapRef.current)
    if (container?._leaflet_id !== null) {
      container._leaflet_id = null
    }
    if (container) {
      let map = L.map(container, {
        fadeAnimation: true,
        zoomControl: false,
        minZoom: 10,
      }).setView([40.3734, 71.7978], 10)
      // let yndx = new L.Yandex(mapType)

      const yndx = L.tileLayer(
        "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          maxZoom: 19,
          className: "map-tiles",
        }
      ).addTo(map)

      map.addLayer(yndx)
      setMapContainer(map)
      let markers = L.markerClusterGroup()

      mapData.forEach((item) => {
        const divElement = document.createElement("div")
        const assignBtn = document.createElement("div")
        const innerHtmlContent = document.createElement("div")
        const customPopupContent = document.createElement("div")

        const imageBox = document.createElement("div")
        imageBox.classList.add("custom-tooltip-image")
        imageBox.innerHTML = `<img src=${
          item?.image?.image ?? DefaultImage
        } alt="image" crossorigin="anonymous" />`
        const title = document.createElement("h3")
        title.textContent = `${
          item?.title?.length > 18
            ? item?.title?.substr(0, 17) + "..."
            : item?.title
        }`

        const firstTitleWithIcons = document.createElement("div")
        firstTitleWithIcons.classList.add("custom-title-with-icons")

        firstTitleWithIcons.innerHTML = `
        <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.00065 0.333496C2.42065 0.333496 0.333984 2.42016 0.333984 5.00016C0.333984 8.50016 5.00065 13.6668 5.00065 13.6668C5.00065 13.6668 9.66732 8.50016 9.66732 5.00016C9.66732 2.42016 7.58065 0.333496 5.00065 0.333496ZM5.00065 6.66683C4.08065 6.66683 3.33398 5.92016 3.33398 5.00016C3.33398 4.08016 4.08065 3.3335 5.00065 3.3335C5.92065 3.3335 6.66732 4.08016 6.66732 5.00016C6.66732 5.92016 5.92065 6.66683 5.00065 6.66683Z" fill="#20AE84"/>
        </svg>
        <span style="color:#323232">${item?.region}</span>
        `
        innerHtmlContent.appendChild(imageBox)
        innerHtmlContent.appendChild(title)
        // innerHtmlContent.appendChild(desc)

        customPopupContent.appendChild(firstTitleWithIcons)

        const secondtTitleWithIconsContainer = document.createElement("div")
        secondtTitleWithIconsContainer.classList.add("custom-title-with-icons")
        secondtTitleWithIconsContainer.innerHTML = `
          <svg width="10" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.0664 0.533447L0.529771 4.71211C0.464882 4.73362 0.408175 4.77456 0.367334 4.82938C0.326495 4.8842 0.303497 4.95025 0.301459 5.01858C0.299422 5.08691 0.318443 5.15422 0.355944 5.21138C0.393444 5.26853 0.447612 5.31278 0.511104 5.33811L6.3331 7.66678L9.2831 13.5668C9.31312 13.6269 9.36059 13.6765 9.41929 13.7091C9.47798 13.7417 9.54517 13.7559 9.61204 13.7497C9.67892 13.7435 9.74236 13.7172 9.79406 13.6744C9.84576 13.6315 9.8833 13.574 9.90177 13.5094L13.4931 0.94078C13.5097 0.88239 13.5101 0.820565 13.4942 0.761979C13.4782 0.703392 13.4466 0.65027 13.4027 0.608345C13.3588 0.56642 13.3043 0.537286 13.245 0.524086C13.1857 0.510887 13.124 0.514123 13.0664 0.533447Z" fill="#20AE84"/>
        </svg>
        `
        const locationButton = document.createElement("span")
        locationButton.textContent = t("draw-route")
        locationButton.classList.add("custom-location-button")
        assignBtn.innerHTML = `<button class="custom-button">${t("view-page")}
      </button>`
        divElement.classList.add("container")

        assignBtn.addEventListener("click", (e) => handleClickMarker(e, item))
        locationButton.addEventListener("click", () => handleClickRoute(item))

        secondtTitleWithIconsContainer.appendChild(locationButton)
        customPopupContent.appendChild(secondtTitleWithIconsContainer)
        innerHtmlContent.appendChild(customPopupContent)
        divElement.appendChild(innerHtmlContent)
        divElement.appendChild(assignBtn)
        const customPopup = divElement
        if (item.favourite) {
          const greenIcon = new L.Icon({
            iconUrl: require("assets/icons/favourite-marker-icon.png"),
            iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
            shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
            iconSize: [27, 41],
            iconAnchor: [12, 41],
            popupAnchor: [5, -35],
            shadowSize: [30, 10],
            shadowAnchor: [10, 10],
          })
          const mark = new L.Marker(item.coords, { icon: greenIcon })
          if (openPopupId === item.id) {
            const mark = L.marker(item.coords).addTo(map)
            mark.bindPopup(customPopup).openPopup()
          }
          mark.bindPopup(customPopup)
          markers.addLayer(mark)
        } else {
          const mark = L.marker(item.coords)
          if (openPopupId === item.id) {
            mark.addTo(map)
            mark.bindPopup(customPopup).openPopup()
          }
          mark.bindPopup(customPopup)
          markers.addLayer(mark)
        }

        // if (openPopupId === item.id) {
        //   const mark = L.marker(item.coords).addTo(map)
        //   mark.bindPopup(customPopup).openPopup()
        // }
      })
      map.addLayer(markers)
      return () => {
        map.off()
        map.remove()
      }
    }
  }, [mapData, mapType])

  const handleClickMarker = (e, data) => {
    dispatch(setOpenPopupId(data.id))
    navigate(`/works/detail/${data.id}`)
    if (token) {
      const postData = { seen: data.id }
      visitorService
        .workUpdate(postData)
        .then(() => {})
        .catch((res) => {
          console.log(res)
        })
      works
        .seen(data.id)
        .then(() => {
          dispatch(fetchUserCreditionals())
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      works
        .seen(data.id)
        .then(() => {})
        .catch((err) => {
          console.log(err)
        })
    }
    // works
    //   .getOne(data.id)
    //   .then((resp) => {
    //     console.log(resp)
    //     showBlured({
    //       title: "",
    //       maxWidth: "487px",
    //       height: "640px",
    //       rounded: "8px",
    //       overflow: "hidden",
    //       withHeader: false,
    //       body: () => <ModalCard close={hideModal} data={resp} inMap />,
    //     })
    //   })
    //   .catch((err) => console.log(err))
  }

  // const handleClickLocationButton = (item) => {
  //   let currentCoords = {}
  //   navigator.geolocation.getCurrentPosition((position) => {
  //     currentCoords["lattitude"] = position.coords?.latitude
  //     currentCoords["longitude"] = position.coords?.longitude
  //   })
  // }

  const handleClickRoute = (data) => {
    if (Object.keys(userLocation)?.length) {
      window.open(
        `https://www.google.com/maps/dir/${userLocation?.lat},${userLocation?.lng}/${data?.coords[0]},${data?.coords[1]}/@40.8519793,69.3912986,8z/data=!3m1!4b1!4m2!4m1!3e0`
      )
    } else {
      error(t("error-route"))
    }
  }

  const handleCardClickRoute = (data) => {
    if (Object.keys(userLocation)?.length) {
      window.open(
        `https://www.google.com/maps/dir/${userLocation?.lat},${userLocation?.lng}/${data?.lat},${data?.lng}/@40.8519793,69.3912986,8z/data=!3m1!4b1!4m2!4m1!3e0`
      )
    } else {
      error(t("error-route"))
    }
  }

  const handleCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const latlng = new L.LatLng(
        parseFloat(position.coords?.latitude),
        parseFloat(position.coords?.longitude)
      )
      const greenIcon = new L.Icon({
        iconUrl: require("assets/icons/currentMarker.png"),
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [25, 41],
        iconAnchor: [12, 12],
        popupAnchor: [0, -10],
        // shadowSize: [0, 0],
        shadowAnchor: [10, 10],
      })
      const mark = new L.Marker(latlng, { icon: greenIcon })
      const featureGroup = new L.FeatureGroup()
      if (mapContainer) {
        featureGroup.addLayer(mark)
        featureGroup?.addTo(mapContainer)
        // setMapContainer(undefined)
        mapContainer.flyTo([latlng.lat, latlng.lng])
      }
    })
  }

  const handleResult = () => {
    setOpenCards(!openCards)
    setOpenFilter(false)
    // setOpenStepper(true)
  }

  const handleFilterOpen = () => {
    setOpenFilter(!openFilter)
    setOpenCards(false)
  }

  const handleClickStepper = () => {
    setOpenStepper(!openStepper)
  }

  const handleZoomMinus = () => {
    mapContainer.setZoom(mapContainer.getZoom() - 1)
  }

  const handleZoomPlus = () => {
    mapContainer.setZoom(mapContainer.getZoom() + 1)
  }

  useEffect(() => {
    setOpenStepper(recommended?.recommends?.title?.length ? true : false)
  }, [recommended])

  // const handleRecommended = (name, value) => {
  //   setRecommended({ [name]: value })
  // }

  const handleFilterChange = (type, value) => {
    setFilterData((prev) => ({ ...prev, [type]: value }))
    setOpenStepper(false)
    setRecommended()
  }

  const handleClear = () => {
    setRecommended({})
    setFilterData({
      year: {},
      group: {},
      region: {},
      category: {},
    })
  }

  return (
    <div className="relative w-full h-full font-[Roboto]">
      {loading ? <Spinner /> : null}
      {openStepper ? (
        <RouteMap
          coordinates={routeCoordinates}
          setMapContainer={setMapContainer}
        />
      ) : (
        <MapSection
          className={classNames("w-full custom-popup")}
          id="map"
          ref={mapRef}
        />
      )}

      <StepperBlock
        open={openStepper}
        className="absolute z-[2200] justify-center w-full left-auto text-black flex gap-[20px]"
      >
        <div className="stepper-box relative border rounded-[16px] bg-white">
          {isLoad ? (
            pattern != 0 ? (
              <Stepper
                recomended={recommended}
                items={pattern}
                steps={stepArray}
                currentStepNumber={currentStep}
              />
            ) : null
          ) : (
            <p className="text-lg font-normal text-center">Loading...</p>
          )}
          <button
            style={{
              boxShadow: "0px 4px 4px rgba(130, 130, 130, 0.25)",
            }}
            onClick={handleClickStepper}
            className="absolute -top-5 -right-5 w-[46px] h-[46px] bg-white flex justify-center items-center rounded-[46px]"
          >
            <MdOutlineClose />
          </button>
        </div>
      </StepperBlock>

      {openStepper ? null : (
        <div className="flex">
          <ListViewed className="absolute z-[2400]">
            <button
              className="rounded-[10px] bg-[#3399FF] text-white py-[14px] px-[14px]"
              onClick={handleResult}
            >
              {t("view-list")}
            </button>
          </ListViewed>

          <Cards
            open={openCards}
            className="fixed z-[2500] top-[80px] p-[40px]"
          >
            <button
              className="fixed lg:px-[14px] pl-6 pr-1 lg:py-[4px] py-5 lg:-ml-[65px] -ml-[65px] lg:rounded-lg rounded-full bg-[#FFFFFF] shadow-xl max-[1021px]:top-[50%]"
              onClick={handleResult}
            >
              <img src={Arrow} alt="arrow" />
            </button>
            {listOpen.length ? (
              <div className="body-cards flex flex-col md:flex-row flex-wrap gap-x-[20px] gap-y-[20px]">
                {listOpen?.map((item, index) => (
                  <MapCards
                    key={index + 1}
                    data={item}
                    width={"277px"}
                    onClick={() => handleCardClickRoute(item)}
                  />
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-full">
                <Empty message="not-found-text" />
              </div>
            )}
          </Cards>
        </div>
      )}

      <div>
        <FilterButton
          className={classNames(
            !openFilter ? "visible scale-100  transition" : "hidden scale-0",
            "absolute top-10 md:top-[60px] left-4 md:left-6 lg:left-[40px] z-[2400] transition duration-150 delay-75 ease-in-out"
          )}
        >
          <button
            onClick={handleFilterOpen}
            className="flex gap-[18px] items-center rounded-[10px] bg-[#3399FF] text-white py-[14px] px-[18px]"
          >
            <Filter aria-hidden="true" color="#fff" size={20} />
            <p className="hidden md:block">{t("filter-title")}</p>
          </button>
        </FilterButton>

        <FilterBlock
          openFilter={openFilter}
          className="fixed z-[2500] top-[120px]"
        >
          <div className="filter-header border-b relative py-[20px] lg:pl-[40px] lg:pr-[18px] md:px-6 px-4 flex justify-between">
            <div className="flex items-center gap-[16px]">
              <Filter aria-hidden="true" color="white" size={20} />
              {t("filter-title")}
            </div>
            <button onClick={handleFilterOpen}>
              <ScreenResizeIcon color={"white"} size={24} />
            </button>
          </div>
          <div className="filter-body py-[30px] lg:px-10 md:px-6 px-4">
            {/* <div>
              <DropdownFilter
                disabled={false}
                label={t("filter-sort")}
                name="recommends"
                options={patternsState}
                placeholder={t("filter-advice")}
                value={recommended?.recommends}
                setValue={handleRecommended}
                // icon={<CiSearch color="#B2C3D7" size={24} />}
                inputBorderClassName="bg-[#EBF2FA]"
              />
            </div> */}
            {filterElement().map((item, index) => {
              // const Icon = item?.icon
              return (
                <div key={index + 1} className={"pt-[25px]"}>
                  <DropdownFilter
                    label={t(`${item?.label}`)}
                    name={item?.name}
                    options={item?.option}
                    placeholder={t(`${item?.label}`)}
                    value={filterData?.[item?.name]}
                    setValue={handleFilterChange}
                    // icon={Icon && <Icon color="#B2C3D7" size={24} />}
                    inputBorderClassName="bg-[#EBF2FA]"
                    language={item?.language}
                  />
                </div>
              )
            })}
            <div className="flex justify-end py-5 mt-10">
              <button
                className="text-red-500 border-b-[1px] border-b-red-500"
                onClick={handleClear}
              >
                {t("filter-clear")}
              </button>
            </div>
          </div>
        </FilterBlock>
      </div>

      <ZoomButton className="absolute z-[2400] bottom-0 md:bottom-[40px] top-1/2 md:top-auto left-5 md:left-auto right-auto lg:right-[200px] md:right-[24px] text-black flex flex-col md:flex-row gap-[20px]">
        <button onClick={handleZoomMinus}>
          <img src={zoomMinus} alt="" />
        </button>
        <button onClick={handleZoomPlus}>
          <img src={zoomPlus} alt="" />
        </button>
        <button onClick={handleCurrentPosition}>
          <img src={myLocation} alt="" width={20} height={20} />
        </button>
      </ZoomButton>

      {/* <div className="absolute z-[2400] top-[45%] left-[110px]">
        <DropDown setMapType={setMapType} mapType={mapType} />
      </div> */}

      {openStepper ? null : (
        <div className="md:top-[133px] top-[15%] right-4 md:right-[40px] absolute z-[2400] py-4 md:py-0 w-[86px] rounded-2xl flex flex-col justify-center items-center">
          <span className="text-2xl font-bold text-white ">
            {sliderData[yearStep[1]]}
          </span>
          <ReactSlider
            className="react-slider-box h-[450px] w-[50px]  flex justify-center items-center border-none my-2"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[0, Number(moment().year()) - 1900]}
            onChange={(e) => setYearStep(e)}
            orientation="vertical"
            max={Number(moment().year()) - 1900}
            minDistance={1}
            invert={true}
            onAfterChange={(e) => setSliderValue(e)}
          />
          <div className="custom-track" />
          <span className="text-2xl font-bold text-white">
            {sliderData[yearStep[0]]}
          </span>
        </div>
      )}

      {/* <div className="px-6 absolute right-[-260px] bottom-[350px] flex justify-center items-center w-[715px] h-[96px] rotate-[270deg] z-[2000] rounded-2xl bg-white">
        <input
          type="range"
          max={100}
          className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer range-lg dark:bg-gray-700"
        />
      </div> */}

      {/* <div className="hidden w-full px-12 pt-5 sm:hidden md:block">
        <Headers />
      </div>
      <div className="text-black block md:hidden py-6 px-2 bg-[color:white]">
        <div className="rounded-3xl h-[50px] px-2 border-[color:#E2E2E2] border-2">
          <InputWithIcon
            onClick={mobileFilter}
            filterIcon
            decoration={<CiSearch color="#CCCCCC" size={25} />}
            inputClassName="bg-transparent"
            className="bg-transparent shadow-none"
          />
        </div>
      </div>
      {!isOpen ? (
        <div className="hidden container w-full md:flex justify-start gap-5 text-[#323232] items-center px-12 py-4">
          <button
            type="button"
            onClick={totggleFilter}
            className={classNames(
              !isOpen
                ? "bg-[#EEF1F2] w-auto h-full px-6 py-2.5 text-lg flex justify-between items-center gap-3 rounded-[5px]"
                : "hidden"
            )}
          >
            <Filter aria-hidden="true" color="#323232" /> Филтер
          </button>
          <div className="w-full max-w-sm">
            <Select
              disabled={false}
              label=""
              name="recommends"
              options={[]}
              placeholder="Тавсия етилганлар"
              value={filters["recommends"]}
              setValue={filterOnHome}
              icon={false}
              innerText={"Саралаш:"}
              inputBorderClassName="border border-[#323232]"
              titleClassName=""
            />
          </div>
        </div>
      ) : null}
      <div
        className={classNames(
          isOpen ? "grid overflow-hidden grid-cols-5 grid-rows-1 gap-1" : "",
          "relative border-2"
        )}
      >
        <div
          className={classNames(
            isOpen
              ? "flex justify-center items-center h-full bg-white col-start-1 col-end-3 2xl:col-end-2 w-full"
              : "hidden w-0 ",
            "transition-width ease-in duration-1000 text-primary-text-color sticky top-0"
          )}
        >
          <FilterOnHome
            handleFilters={filterOnHome}
            closeFiter={totggleFilter}
            clearFilters={clearFilter}
            filters={localFilters}
            collapsable={true}
          />
        </div>
        <div
          className={classNames(
            isOpen ? "col-start-3 2xl:col-start-2 col-end-12" : "w-full",
            "flex flex-col justify-start items-start gap-4"
          )}
        >
          {isOpen ? (
            <div className="w-full h-12 max-w-sm text-black">
              <Select
                disabled={false}
                label=""
                name="recommends"
                options={[]}
                placeholder="Тавсия етилганлар"
                value={filters["recommends"]}
                setValue={filterOnHome}
                icon={false}
                innerText={"Саралаш:"}
                inputBorderClassName="border border-[#323232]"
                titleClassName=""
              />
            </div>
          ) : null}
          <MapSection
            className={classNames("w-full custom-popup")}
            id="map"
            ref={mapRef}
          />
        </div>
        <button
          className="mb-10 current-position md:mb-0"
          onClick={handleCurrentPosition}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.5725 9.99989C18.5725 14.7338 14.735 18.5713 10.0011 18.5713M18.5725 9.99989C18.5725 5.26603 14.735 1.42847 10.0011 1.42847M18.5725 9.99989H15.144M10.0011 18.5713C5.26725 18.5713 1.42969 14.7338 1.42969 9.99989M10.0011 18.5713V15.1428M1.42969 9.99989C1.42969 5.26603 5.26725 1.42847 10.0011 1.42847M1.42969 9.99989H4.85826M10.0011 1.42847V4.85704"
              stroke="#323232"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <DropDown setMapType={setMapType} mapType={mapType} />
        <div className="md:hidden absolute bottom-0 w-[100%] z-[1400]">
          <FooterNavbar />
        </div>
      </div> */}
    </div>
  )
}

export default Home
